import { Close as CloseIcon } from "@mui/icons-material";
import { Box, Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DEFAULT_DRAG_HANDLE_SELECTOR } from "../../../../app/constants";
import { ReactComponent as EditIcon } from "../../../../common/icons/editDark.svg";
import { CustomButton } from "../../../../common/components/functional/customButton/CustomButton";

type Props = {
  editDisabled: boolean;
  onEdit: () => void;
  onCancel: () => void;
  canEdit: boolean;
};

const ActionButtons = ({ editDisabled, onEdit, onCancel, canEdit }: Props) => {
  const { t } = useTranslation();

  return (
    <Grid
      className={DEFAULT_DRAG_HANDLE_SELECTOR}
      item
      xs={12}
      sx={{ cursor: "grab" }}
    >
      <Box width="100%" display="flex" justifyContent="space-between" mt={1}>
        <Button
          onClick={onCancel}
          startIcon={<CloseIcon />}
          variant="outlined"
          sx={{
            borderRadius: "15px",
            maxHeight: "30px",
          }}
        >
          {t("common:close")}
        </Button>
        <CustomButton
          accessRightChecks={[canEdit]}
          disabled={editDisabled}
          onClick={onEdit}
          startIcon={<EditIcon />}
          variant="outlined"
          sx={{
            borderRadius: "15px",
            maxHeight: "30px",
          }}
        >
          {t("talentProfile:makeCorrection")}
        </CustomButton>
      </Box>
    </Grid>
  );
};

export default ActionButtons;
